/* Pravilo – Supplements-Karussell.
   Mitte groß, Nachbarn klein und blass. Wechsel per Wischen, Pfeil, Tastatur oder Klick auf den Nachbarn.
   Name, Inhalt und Preis blenden kurz aus und neu ein. Reduzierte Bewegung: sofortiger Wechsel ohne Gleiten. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mount(root) {
    if (root.dataset.suppReady) return;
    const slides = [...root.querySelectorAll('[data-supp-slide]')];
    if (!slides.length) return;
    root.dataset.suppReady = '1';

    const stage = root.querySelector('[data-supp-stage]');
    const info = root.querySelector('[data-supp-info]');
    const nameEl = root.querySelector('[data-supp-name]');
    const subEl = root.querySelector('[data-supp-sub]');
    const linkEl = root.querySelector('[data-supp-link]');
    const priceEl = root.querySelector('[data-supp-price]');
    const qtyEl = root.querySelector('[data-supp-qty]');
    const addBtn = root.querySelector('[data-supp-add]');
    const statusEl = root.querySelector('[data-supp-status]');
    const prevBtn = root.querySelector('[data-supp-prev]');
    const nextBtn = root.querySelector('[data-supp-next]');
    const tabs = [...root.querySelectorAll('[data-supp-tab]')];
    const picks = [...root.querySelectorAll('[data-supp-pick]')];
    const qtyWrap = root.querySelector('[data-supp-qty-wrap]');
    const factsEl = root.querySelector('[data-supp-facts]');
    const countEl = root.querySelector('[data-supp-count]');

    let list = slides.map((_, i) => i);
    let pos = 0;
    let qty = 1;
    let swapTimer = 0;

    const fill = slide => {
      nameEl.textContent = slide.dataset.name;
      subEl.textContent = slide.dataset.sub;
      linkEl.href = slide.dataset.url;
      priceEl.textContent = slide.dataset.price;
      const available = slide.dataset.available === 'true';
      addBtn.disabled = !available;
      addBtn.textContent = available ? 'In den Warenkorb' : 'Aktuell ausverkauft';
      if (qtyWrap) qtyWrap.hidden = !available;
      statusEl.textContent = '';
      if (factsEl) {
        factsEl.replaceChildren(...(slide.dataset.facts || '').split('|').filter(Boolean).map(text => {
          const li = document.createElement('li'); li.textContent = text; return li;
        }));
      }
    };

    const showInfo = (slide, animate) => {
      clearTimeout(swapTimer);
      if (!animate || reduced.matches) { info.classList.remove('is-swapping'); fill(slide); return; }
      info.classList.add('is-swapping');
      swapTimer = setTimeout(() => {
        fill(slide);
        requestAnimationFrame(() => info.classList.remove('is-swapping'));
      }, 200);
    };

    const render = animate => {
      const n = list.length;
      slides.forEach((el, i) => {
        const k = list.indexOf(i);
        if (k < 0) { el.hidden = true; return; }
        el.hidden = false;
        let d = k - pos;
        if (n > 2) { if (d > n / 2) d -= n; if (d < -n / 2) d += n; }
        const ad = Math.abs(d);
        el.style.setProperty('--d', d);
        el.style.setProperty('--a', ad);
        el.style.setProperty('--s', ad === 0 ? 1 : 0.52);
        el.style.setProperty('--o', ad === 0 ? 1 : ad === 1 ? 0.62 : 0);
        el.style.zIndex = String(10 - ad);
        el.classList.toggle('is-active', ad === 0);
        el.classList.toggle('is-near', ad === 1);
        el.setAttribute('aria-hidden', ad === 0 ? 'false' : 'true');
        const link = el.querySelector('a');
        if (link) link.tabIndex = ad === 0 ? 0 : -1;
      });
      const single = n < 2;
      prevBtn?.toggleAttribute('hidden', single);
      nextBtn?.toggleAttribute('hidden', single);
      picks.forEach(p => p.setAttribute('aria-pressed', String(Number(p.dataset.suppPick) === list[pos])));
      if (countEl) countEl.textContent = `${pos + 1} / ${n}`;
      showInfo(slides[list[pos]], animate);
    };

    const go = step => {
      const n = list.length;
      if (n < 2) return;
      pos = (pos + step + n) % n;
      render(true);
    };

    prevBtn?.addEventListener('click', () => go(-1));
    nextBtn?.addEventListener('click', () => go(1));
    root.addEventListener('keydown', event => {
      if (!stage.contains(event.target)) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); go(1); }
    });

    /* Klick auf einen Nachbarn holt ihn in die Mitte statt die Produktseite zu öffnen */
    slides.forEach((el, i) => el.addEventListener('click', event => {
      if (el.classList.contains('is-active') || dragged) return;
      event.preventDefault();
      const k = list.indexOf(i);
      if (k < 0) return;
      pos = k;
      render(true);
    }));

    /* Wischen: waagerecht ab 40 px, senkrechtes Scrollen bleibt frei (touch-action: pan-y) */
    let startX = 0, startY = 0, tracking = false, dragged = false;
    stage.addEventListener('pointerdown', event => {
      tracking = true; dragged = false; startX = event.clientX; startY = event.clientY;
    });
    stage.addEventListener('pointerup', event => {
      if (!tracking) return;
      tracking = false;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        dragged = true;
        go(dx < 0 ? 1 : -1);
        setTimeout(() => { dragged = false; }, 0);
      }
    });
    stage.addEventListener('pointercancel', () => { tracking = false; });
    stage.addEventListener('click', event => { if (dragged) { event.preventDefault(); event.stopPropagation(); } }, true);

    picks.forEach(pick => pick.addEventListener('click', () => {
      const k = list.indexOf(Number(pick.dataset.suppPick));
      if (k < 0 || k === pos) return;
      pos = k;
      render(true);
    }));

    tabs.forEach(tab => tab.addEventListener('click', () => {
      const kind = tab.dataset.suppTab;
      tabs.forEach(t => t.setAttribute('aria-pressed', String(t === tab)));
      list = slides.map((el, i) => (!kind || el.dataset.kind === kind ? i : -1)).filter(i => i >= 0);
      pos = 0;
      render(true);
    }));

    const setQty = value => { qty = Math.min(10, Math.max(1, value)); qtyEl.textContent = String(qty); };
    root.querySelector('[data-supp-minus]')?.addEventListener('click', () => setQty(qty - 1));
    root.querySelector('[data-supp-plus]')?.addEventListener('click', () => setQty(qty + 1));

    addBtn.addEventListener('click', async () => {
      const slide = slides[list[pos]];
      const add = window.PraviloTheme?.addToCart;
      if (!add) { window.location.href = slide.dataset.url; return; }
      addBtn.disabled = true;
      addBtn.classList.add('is-busy');
      try {
        await add(slide.dataset.variant, qty);
        setQty(1);
      } catch (error) {
        statusEl.textContent = error.message || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
      } finally {
        addBtn.classList.remove('is-busy');
        addBtn.disabled = slide.dataset.available !== 'true';
      }
    });

    render(false);
    requestAnimationFrame(() => root.classList.add('is-ready'));
  }

  const init = scope => scope.querySelectorAll('[data-supp]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
